import React, { useEffect, useState } from 'react'
import DefaultHeading from '../../components/heading/DefaultHeading'
import { getMetaData, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import "./EventConfig.css"
import { Button, CircularProgress, Container } from '@mui/material';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { configurationAttributeType } from '../../types';
import { eventsType, singleEventType } from './EventType';
import SingleEvent from '../../components/eventConfig/SingleEvent';
import NoDataMessage from '../../components/manageEvents/NoEventsMessage';
import DefaultParamsModal from '../../components/eventConfig/DefaultParamsModal';


function EventConfig() {
    const config_name = 'analytics_config';
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [events, setEvents] = useState<eventsType>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false)

    const updateEventState = (eventId: string, newSate: singleEventType): void => {
        setEvents((pre: eventsType) => {
            return ({
                ...pre,
                [eventId]: { ...newSate }
            })
        })
    }


    const handleDefaultParamClick = () => {
        setModalOpen(true);
    }

    async function getEventsData(): Promise<void> {
        setLoading(true)
        try {
            const response = await getMetaData("clientconfig", config_name);
            let data = {}
            if (response) {
                const eventsData = response.find((item: any) => item.name === "events");
                if (eventsData) {
                    data = deepClone(eventsData.value[0]);
                }
            }
            setEvents(data);

        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);
        }
    }

    const validateData = (data: eventsType): string | null => {
        // add validations here
        return null;
    }


    const saveConfiguration = async () => {
        setIsSaving(true);
        try {

            const validationResults = validateData(events);

            if (!validationResults || validationResults === "") {
                let response = await getMetaData("clientconfig", config_name);
                let configData = [{
                    name: "events",
                    type: "list",
                    value: [events],
                    description: "list of events",
                    possibleVals: [],
                    docUrl: "",
                }]
                let result = null
                if (!response) {
                    result = await postConfiguration(config_name, configData as configurationAttributeType<any>[])
                } else {
                    const indexOfEventInConfig = response.findIndex((item: { name: string }) => item.name === "events");
                    if (indexOfEventInConfig === -1) {
                        configData = [...configData, ...response]
                    } else {
                        response[indexOfEventInConfig] = configData[0];
                        configData = [...response];
                    }
                    result = await updateConfiguration(config_name, configData as configurationAttributeType<any>[])
                }

                if (result.data?.status === "Failure") {
                    throw new Error("")
                } else {
                    openPopup('Success', `Data saved`)
                }
            } else {
                openPopup("Error", validationResults)
            }
        } catch (error) {
            console.error(error)
            openPopup('Error', "An error occurred while saving data.")
        } finally {
            setIsSaving(false);
        }
    }

    useEffect(() => {
        getEventsData();
    }, [])

    return (
        <div className='event-config-wrapper'>
            <DefaultParamsModal
                open={modalOpen}
                handleModalClose={() => setModalOpen(false)}
            />
            <DefaultHeading heading='Event Config'>
                {
                    Object.keys(events).length > 0 ? <>
                        <Button variant="contained" onClick={handleDefaultParamClick}>
                            Default Params
                        </Button>
                        <Button className='manage-event-save-button' variant="contained" sx={{ backgroundColor: "#23c6b0" }} onClick={saveConfiguration} disabled={isSaving}>
                            {isSaving ? 'Saving...' : 'Save'}
                        </Button>
                    </>
                        : <></>
                }
            </DefaultHeading>

            {
                loading ?
                    <Container className='manage-event-loading-wrapper'>
                        <CircularProgress size={70} />
                    </Container> :
                    Object.keys(events).length === 0 ? <NoDataMessage message="No Events Added" /> :
                        <div className='event-config-events-list'>
                            {
                                events && Object.keys(events).map((itemKey: string) => {
                                    return <SingleEvent key={events[itemKey].id} event={events[itemKey]} updateEventState={updateEventState} />
                                })
                            }
                        </div>
            }
        </div>
    )
}

export default EventConfig